<template>
  <div class="userRz">
    <div class="inner">
      <div class="typeContent">
        <p class="title">
          实名认证
        </p>
        <div v-if="gUserInfo.userDetailResult.type==0">
          <div class="innerContent">
            <div class="rzSuccess">
              <img src="../../assets/images/icon_green.png" alt="" class="successImg" v-show="status ==1">
              <p class="t1" v-show="status ==1">
                实名认证成功
              </p>
              <img src="../../assets/images/sh.png" alt="" class="successImg" v-show="status ==0">
              <p class="t1" v-show="status ==0">
                认证中...
              </p>
              <img src="../../assets/images/icon_red.png" alt="" class="successImg" v-show="status ==2">
              <p class="t1" v-show="status ==2">
                认证失败,请重新认证！
              </p>
              <div class="successContent" v-if="(status ==0 ||status ==1) && userData.userInfo">
                <p class="successTitle">
                  <img src="../../assets/images/icon_information.png" alt="">
                  实名认证信息
                </p>
                <div class="successInfo">
                  <section>
                    <div class="name">姓名：</div>
                    <div class="t2">{{userData.userInfo.name}}</div>
                  </section>
                  <section>
                    <div class="name">身份证号码：</div>
                    <div class="t2">{{userData.userInfo.id_card}}</div>
                  </section>
                  <section>
                    <div class="name">邮箱：</div>
                    <div class="t2">{{userData.userInfo.email}}</div>
                  </section>
                  <section>
                    <div class="name">身份证正面：</div>
                    <img :src="userData.userInfo.card_front" @click="lookPic(userData.userInfo.card_front)" alt="" class="p1">
                  </section>
                  <section>
                    <div class="name">身份证背面：</div>
                    <img :src="userData.userInfo.card_behind" @click="lookPic(userData.userInfo.card_behind)" alt="" class="p1">
                  </section>
                  <section>
                    <div class="name">手持身份证照片：</div>
                    <img :src="userData.userInfo.card_person" @click="lookPic(userData.userInfo.card_person)" alt="" class="p2">
                  </section>
                </div>
              </div>
            </div>
          </div>
          <div class="innerContent" v-if="status ==3||status ==2">
            <div class="userSure">
              <section>
                <div class="sureHeader vaM">真实姓名</div>
                <el-input class="seInput" v-model="name" placeholder="请输入内容"></el-input>
              </section>
              <section>
                <div class="sureHeader vaM">身份证号</div>
                <el-input class="seInput" v-model="card_front" placeholder="请输入内容"></el-input>
              </section>
              <section>
                <div class="sureHeader vaM">邮箱</div>
                <el-input class="seInput" v-model="email" placeholder="请输入内容"></el-input>
                <p class="orageColor">注：此邮箱将用于接收相关签约节点信息</p>
              </section>
              <section>
                <div class="sureHeader">身份证正面照</div>
                <el-upload
                  class="avatar-uploader"
                  action="http://www.absign.cn:8080/api/common/files/upload"
                  :show-file-list="false"
                  accept="image/*"
                  :on-success="handleAvatarSuccesszm"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="imageUrlzm" :src="cimageUrlzm" class="avatar">
                  <i v-else class="zhengmian"></i>
                </el-upload>
                <div class="sl">
                  <img src="../../assets/images/pic_zheng.png" alt="">
                  <p>示例</p>
                </div>
              </section>
              <section>
                <div class="sureHeader">身份证反面照</div>
                <el-upload
                  class="avatar-uploader"
                  action="http://www.absign.cn:8080/api/common/files/upload"
                  :show-file-list="false"
                  accept="image/*"
                  :on-success="handleAvatarSuccessfm"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="imageUrlfm" :src="cimageUrlfm" class="avatar">
                  <i v-else class="fanmian"></i>
                </el-upload>
                <div class="sl">
                  <img src="../../assets/images/pic_fan.png" alt="">
                  <p>示例</p>
                </div>
              </section>
              <section>
                <div class="sureHeader">手持身份证正面照</div>
                <el-upload
                  class="avatar-uploader sc"
                  action="http://www.absign.cn:8080/api/common/files/upload"
                  :show-file-list="false"
                  accept="image/*"
                  :on-success="handleAvatarSuccesssc"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="imageUrlsczm" :src="cimageUrlsczm" class="avatar">
                  <i v-else class="zmi"></i>
                </el-upload>
                <div class="sl">
                  <img src="../../assets/images/pic_shi.png" alt="">
                  <p>示例</p>
                </div>
              </section>
            </div>
            <div class="sx"></div>
            <div class="btns">
              <!--<el-button>取消</el-button>-->
              <el-button type="primary" class="bl" @click="sub(0)">提交审核</el-button>
            </div>
          </div>
        </div>
        <div v-if="gUserInfo.userDetailResult.type==1">
          <div class="innerContent">
            <div class="rzSuccess">
              <img src="../../assets/images/icon_green.png" alt="" class="successImg" v-show="status ==1">
              <p class="t1" v-show="status ==1">
                实名认证成功
              </p>
              <img src="../../assets/images/sh.png" alt="" class="successImg" v-show="status ==0">
              <p class="t1" v-show="status ==0">
                认证中...
              </p>
              <img src="../../assets/images/icon_red.png" alt="" class="successImg" v-show="status ==2">
              <p class="t1" v-show="status ==2">
                认证失败,请重新认证！
              </p>
              <div class="successContent" v-if="(status ==0 ||status ==1) &&userData.companyInfo">
                <p class="successTitle">
                  <img src="../../assets/images/icon_information.png" alt="">
                  实名认证信息
                </p>
                <div class="successInfo">
                  <section>
                    <div class="name">企业全称：</div>
                    <div class="t2">{{userData.companyInfo.company}}</div>
                  </section>
                  <section>
                    <div class="name">统一社会信用代码：</div>
                    <div class="t2">{{userData.companyInfo.code}}</div>
                  </section>
                  <section>
                    <div class="name">法人名称：</div>
                    <div class="t2">{{userData.companyInfo.corporation_name}}</div>
                  </section>
                  <section>
                    <div class="name">法人身份证号：</div>
                    <div class="t2">{{userData.companyInfo.corporation_id_card}}</div>
                  </section>
                  <section>
                    <div class="name">法人电话：</div>
                    <div class="t2">{{userData.companyInfo.corporation_phone}}</div>
                  </section>
                  <section>
                    <div class="name">法人邮箱：</div>
                    <div class="t2">{{userData.companyInfo.email}}</div>
                  </section>
                  <section>
                    <div class="name">营业执照：</div>
                    <img @click="lookPic(userData.companyInfo.business_license)" :src="userData.companyInfo.business_license" alt="" class="p2">
                  </section>
                  <section>
                    <div class="name">身份证正面：</div>
                    <img @click="lookPic(userData.companyInfo.operator_card_front)" :src="userData.companyInfo.operator_card_front" alt="" class="p1">
                  </section>
                  <section>
                    <div class="name">身份证背面：</div>
                    <img @click="lookPic(userData.companyInfo.operator_card_behind)" :src="userData.companyInfo.operator_card_behind" alt="" class="p1">
                  </section>
                </div>
              </div>
            </div>
          </div>
          <div class="innerContent" v-if="status ==3 ||status ==2">
            <div class="onePage" v-show="showPage">
              <div class="userSure">
                <section>
                  <div class="sureHeader vaM">企业全称</div>
                  <el-input class="seInput" v-model="company" placeholder="请输入内容"></el-input>
                </section>
                <section>
                  <div class="sureHeader vaM">统一社会信用代码</div>
                  <el-input class="seInput" v-model="code" placeholder="请输入内容"></el-input>
                </section>
                <section>
                  <div class="sureHeader vaM">法人姓名</div>
                  <el-input class="seInput" v-model="corporation_name" placeholder="请输入内容"></el-input>
                </section>
                <section>
                  <div class="sureHeader vaM">法人身份证号</div>
                  <el-input class="seInput" v-model="corporation_id_card" placeholder="请输入内容"></el-input>
                </section>
                <section>
                  <div class="sureHeader vaM">法人电话</div>
                  <el-input class="seInput" v-model="corporation_phone" placeholder="请输入内容"></el-input>
                </section>
                <section>
                  <div class="sureHeader vaM">法人邮箱</div>
                  <el-input class="seInput" v-model="email" placeholder="请输入内容"></el-input>
                  <p class="orageColor">注：此邮箱将用于接收相关签约节点信息</p>
                </section>
                <section>
                  <div class="sureHeader">电子合同服务授权书</div>
                  <p class="t5" @click="downDoc" style="cursor: pointer">《ABSign TM电子合同服务授权书模板》</p>
                  <span class="downBtn" @click="downDoc" style="cursor: pointer">点击下载</span>
                  <p class="t6">请先下载模板，将模板中需要的信息补充完整，打印盖章后，再次上传此文件</p>
                </section>
                <section>
                  <div class="sureHeader">电子合同授权书</div>
                  <el-upload
                    style="width:90px;display:inline-block"
                    action="http://www.absign.cn:8080/api/common/files/uploadPrivae"
                    :show-file-list="false"
                    :headers="{'x-access-token':gUserInfo.token}"
                    :on-success="handleAvatarSuccess"
                    accept="application/pdf"
                    :before-upload="beforeAvatarUploadk">
                    <span class="downBtn up">点击上传</span>
                  </el-upload>
                  <span style="font-size: 12px;margin-left: 15px">{{service_name}}</span>
                </section>
              </div>
              <div class="sx"></div>
              <div class="btns" style="width: 160px">
                <el-button type="primary" class="bl" @click="showPage = !showPage">下一步</el-button>
              </div>
            </div>
            <div class="twoPage" v-show="!showPage">
              <div class="userSure">
                <section>
                  <div class="sureHeader">营业执照</div>
                  <el-upload
                    class="avatar-uploader"
                    action="http://www.absign.cn:8080/api/common/files/upload"
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="handleAvatarSuccessyy"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="yyzz":src="cyyzz" class="avatar">
                    <i v-else class="fanmian"></i>
                  </el-upload>
                  <div class="sl">
<<<<<<< HEAD
                    <img src="../../assets/images/67031554974898_.pic_hd.jpg" alt="">
=======
                    <img width="100" src="../../assets/images/timg.jpeg" alt="">
>>>>>>> cbc4a95fa3a56cc33db60379a058229fa0130379
                    <p>示例</p>
                  </div>
                </section>
                <section>
                  <div class="sureHeader">经办人身份证正面照</div>
                  <el-upload
                    class="avatar-uploader"
                    action="http://www.absign.cn:8080/api/common/files/upload"
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="handleAvatarSuccesszm"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrlzm" :src="cimageUrlzm" class="avatar">
                    <i v-else class="zhengmian"></i>
                  </el-upload>
                  <div class="sl">
                    <img src="../../assets/images/pic_zheng.png" alt="">
                    <p>示例</p>
                  </div>
                </section>
                <section>
                  <div class="sureHeader">经办人身份证反面照</div>
                  <el-upload
                    class="avatar-uploader"
                    action="http://www.absign.cn:8080/api/common/files/upload"
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="handleAvatarSuccessfm"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrlfm" :src="cimageUrlfm" class="avatar">
                    <i v-else class="fanmian"></i>
                  </el-upload>
                  <div class="sl">
                    <img src="../../assets/images/pic_fan.png" alt="">
                    <p>示例</p>
                  </div>
                </section>
              </div>
              <div class="sx"></div>
              <div class="btns">
                <el-button @click="showPage = !showPage">上一步</el-button>
                <el-button type="primary" class="bl" @click="sub(1)">下一步</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="picWarp" v-show="showPicUrl!=''" @click="showPicUrl=''">
      <img :src="showPicUrl" alt="">
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {mapGetters} from 'vuex'
  export default {
    data() {
      return {
        service_name:'',
        service_url:'',
        status:'',
        userData: {},
        card_front:'',
        name:'',
        email:'',
        imageUrlzm:'',
        imageUrlfm:'',
        imageUrlsczm:'',
        yyzz:'',
        cyyzz:'',
        cimageUrlzm:'',
        cimageUrlfm:'',
        cimageUrlsczm:'',
        company:'',
        code:'',
        corporation_name:'',
        corporation_id_card:'',
        corporation_phone:'',
        upType:'',
        showPage:true,
        showPicUrl:''
      }
    },
    created() {
      this.getData();
    },
    computed: {
      ...mapGetters([
        "gUserInfo"
      ])
    },
    methods: {
      lookPic(url){
        this.showPicUrl = url
      },
      getData() {
        let _this = this;
        _this.ajpost('/api/account/index', {}, function (datas) { // 0/待处理 1/已认证 2/认证失败 3/没有提交认证 ,
          _this.status = datas.data.status;
          if (datas.data.status != 3) {
            _this.ajpost('/api/user/findAuthInfo', {}, function (data) {
              console.log(data)
              _this.userData = data.data;
            });
          }
        })
      },
      beforeAvatarUpload(e){
        console.log(e)
      },
      handleAvatarSuccess(data){
        for(let key in data.data){
          this.service_url = data.data[key]
        }
      },
      beforeAvatarUploadk(data){
        this.service_name = data.name
      },
      handleAvatarSuccesszm(data){
        for(let key in data.data){
          if(key!='imageUrl'){
            this.imageUrlzm  = data.data[key]
          }
        }
        this.cimageUrlzm  = data.data.imageUrl
      },
      handleAvatarSuccessfm(data){
        for(let key in data.data){
          if(key!='imageUrl'){
            this.imageUrlfm  = data.data[key]
          }
        }
        this.cimageUrlfm  = data.data.imageUrl
      },
      handleAvatarSuccesssc(data){
        for(let key in data.data){
          if(key!='imageUrl'){
            this.imageUrlsczm  = data.data[key]
          }
        }
        this.cimageUrlsczm  = data.data.imageUrl
      },
      handleAvatarSuccessyy(data){
        for(let key in data.data){
          if(key!='imageUrl'){
            this.yyzz  = data.data[key]
          }
        }
        this.cyyzz  = data.data.imageUrl
      },
      sub(type){
        let _this = this,obj;
        var email = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
          idcard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if(type ==0){
          if(_this.name ==''){
            this.$message({
              message: '请输入您的姓名',
              type: 'warning'
            });
            return;
          }else if(_this.card_front ==''){
            this.$message({
              message: '请输入您的身份证号码',
              type: 'warning'
            });
            return;
          }else if(!idcard.test(_this.card_front)){
            this.$message({
              message: '请输入正确的身份证号',
              type: 'warning'
            });
            return;
          }else if(_this.email ==''){
            this.$message({
              message: '请输入您的邮箱',
              type: 'warning'
            });
            return;
          }else if(!email.test(_this.email)){
            this.$message({
              message: '请输入正确的邮箱',
              type: 'warning'
            });
            return;
          }else if(_this.imageUrlzm ==''){
            this.$message({
              message: '请上传身份证正面照',
              type: 'warning'
            });
            return;
          }else if(_this.imageUrlfm ==''){
            this.$message({
              message: '请上传身份证反面照',
              type: 'warning'
            });
            return;
          }else if(_this.imageUrlsczm ==''){
            this.$message({
              message: '请上传身份证反面照',
              type: 'warning'
            });
            return;
          }else {
            obj = {
              type: 0,
              userAuth: {
                "card_behind": _this.imageUrlfm,
                "card_front": _this.imageUrlzm,
                "card_person": _this.imageUrlsczm,
                "email": _this.email,
                "id_card": _this.card_front,
                "name": _this.name
              }
            };
          }
        }
        else{
          if(_this.company ==''){
            this.$message({
              message: '请输入企业名称',
              type: 'warning'
            });
            return;
          }else if(_this.code ==''){
            this.$message({
              message: '请输入统一社会信用代码',
              type: 'warning'
            });
            return;
          }else if(_this.code.length!=18){
            this.$message({
              message: '请输入正确的统一社会信用代码',
              type: 'warning'
            });
            return;
          }else if(_this.corporation_name ==''){
            this.$message({
              message: '请输入法人姓名',
              type: 'warning'
            });
            return;
          }else if(_this.corporation_id_card ==''){
            this.$message({
              message: '请输入法人身份证号',
              type: 'warning'
            });
            return;
          }else if(!idcard.test(_this.corporation_id_card)){
            this.$message({
              message: '请输入正确的法人身份证',
              type: 'warning'
            });
            return;
          }else if(_this.corporation_phone ==''){
            this.$message({
              message: '请输入法人手机号',
              type: 'warning'
            });
            return;
          }else if(!email.test(_this.email)){
            this.$message({
              message: '请输入正确的法人邮箱',
              type: 'warning'
            });
            return;
          }else if(_this.email ==''){
            this.$message({
              message: '请输入法人邮箱',
              type: 'warning'
            });
            return;
          }else if(_this.yyzz ==''){
            this.$message({
              message: '请上传营业执照',
              type: 'warning'
            });
            return;
          }else if(_this.imageUrlzm ==''){
            this.$message({
              message: '请上传经办人身份证正面照',
              type: 'warning'
            });
            return;
          }else if(_this.imageUrlfm ==''){
            this.$message({
              message: '请上传经办人身份证反面照',
              type: 'warning'
            });
            return;
          }else if(_this.service_name ==''){
            this.$message({
              message: '请上传电子合同授权书',
              type: 'warning'
            });
            return;
          }else {
            obj = {
              type: 1,
              companyAuth: {
                "business_license": _this.yyzz,
                "code": _this.code,
                "company": _this.company,
                "corporation_id_card": _this.corporation_id_card,
                "corporation_name": _this.corporation_name,
                "corporation_phone": _this.corporation_phone,
                "email": _this.email,
                "operator_card_behind": _this.imageUrlfm,
                "operator_card_front": _this.imageUrlzm,
                "service_name": _this.service_name,
                "service_url": _this.service_url
              }
            };
          }
        }
        _this.ajpost('/api/user/addAuth',obj,function (data) {
          if(data.data.code =='0'){
            _this.$message({
              message: '提交成功',
              type: 'success'
            });
            _this.getData();
          }else {
            _this.$message({
              message: data.data.msg,
              type: 'warning'
            });
          }
        })
      },
      downDoc(){
        window.open('https://absign.oss-cn-beijing.aliyuncs.com/%E7%94%B5%E5%AD%90%E5%90%88%E5%90%8C%E6%9C%8D%E5%8A%A1%E6%8E%88%E6%9D%83%E4%B9%A6.doc')
      }
    }
  }
</script>
<style>
  @import "../../assets/less/userRz.css";
</style>



// WEBPACK FOOTER //
// src/components/userCenter/userRz.vue